<app-toolbar></app-toolbar>

<div *ngIf="isLoading">
  <app-loading></app-loading>
</div>
<div class="main-layout content">
  <!-- Left Card -->
  <div class="left-card">
    <div class="card">
      <h1 class="title">List of decisions</h1>
      <p class="decision-constraint">Only one decision is allowed per turn</p>

      <div class="card-content" *ngIf="!isLoading">
        @for (decision of decisions; track decision.decision; let i = $index) {
        <div
          class="decision-radio"
          [class.disabled]="isDecisionDisabled(decision)"
        >
          <div style="display: flex; align-items: baseline">
            <input
              type="radio"
              [id]="'decision' + i"
              name="decision"
              class="decision-radio-input"
              [value]="decision.decision"
              [checked]="selectedDecision?.decision === decision.decision"
              (change)="onDecisionChange(decision)"
              [disabled]="isDecisionDisabled(decision)"
            />
            <div>
              <div style="display: flex">
                <p class="decision-name">
                  {{ decision.decision }}
                </p>
                <mat-icon
                  class="info-icon"
                  matTooltip="{{ decision.description }}"
                  matTooltipPosition="above"
                >
                  info
                </mat-icon>
              </div>
              <div style="display: flex">
                <p class="decision-description">
                  Impact: <span> {{ decision.scope }} </span>
                  <span *ngIf="decision.scope != 'Whole organization'">
                    members
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="weeks">
            <p>
              Implementation:
              <span>{{ decision.weeks_for_implementation }} Weeks</span>
            </p>
            <p>
              Until Reuse: <span>{{ decision.weeks_until_reuse }} Weeks</span>
            </p>
          </div>
        </div>
        }
      </div>

      <div class="card-actions" *ngIf="!isLoading">
        <button class="start-over-btn btn" (click)="startOver()">
          Start Over
        </button>
        <div>
          <button class="clear-btn btn" (click)="clearSelection()">
            Clear
          </button>
          <button
            [disabled]="!isValidToTakeAction()"
            [disabled]="!isValidToTakeAction()"
            class="take-action-btn btn"
            (click)="takeAction()"
            [matTooltip]="showTooltip()"
            matTooltipPosition="above"
          >
            Take Action
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Side -->
  <div class="right-side">
    <div class="card">
      <div class="card-header">
        <h1 class="title">Organizational Chart</h1>
        <app-stages *ngIf="!isLoading"></app-stages>
      </div>

      <div *ngIf="selectedDecision" class="counter">
        {{ checkedNodes.length }} /
        {{
          selectedDecision.scope == "Whole organization"
            ? "20"
            : selectedDecision.scope
        }}
      </div>
      <div
        *ngIf="!isLoading"
        style="flex: 1; overflow: auto; padding: 10px; position: relative"
      >
        <div
          [style.transform]="'scale(' + scale + ')'"
          style="
            transform-origin: top left;
            transition: transform 0.2s ease-in-out;
          "
        >
          <app-organization-chart
            [organizationChart]="organizationChart"
            [showCheckBox]="true"
            [showPhaseIndicator]="true"
            [maxNumberOfChecked]="selectedDecision?.scope"
            (nodeSelectionChange)="onNodeSelectionChange($event)"
            [progress]="progressOrgChart"
          ></app-organization-chart>
        </div>
      </div>

      <div class="zoom-btns-container">
        <button class="zoom-btns btn" (click)="zoomOut()">-</button>
        <button class="zoom-btns btn" (click)="zoomIn()">+</button>
      </div>
    </div>
  </div>
  <!-- Bottom Side -->
  <div class="adoption-stage-box">
    <app-adoption-stage
      [value]="progressAdoptionStageOfOrganizationInNumber"
    ></app-adoption-stage>

    <app-credibility [credibility]="progressCredibility"></app-credibility>

    <app-useful-weeks
      [weeksProgress]="progressUsefulWeeks.weeksScore"
    ></app-useful-weeks>

    <app-critical-mass
      [criticalMass]="progressCriticalMass"
    ></app-critical-mass>
  </div>
</div>
